<template>
    <li ref="projectTimeLogTimerListItemRef" class="list-group-item">
        <div class="row">
            <div class="col-xs-7">
                <a class="btn btn-link bs3-padding-left-reset" :href="viewProjectUrl" style="display: block; text-align: left; overflow-x: hidden; text-overflow: ellipsis;">
                    <i class="fa-light fa-stopwatch" aria-hidden="true"></i> {{ pData.mediaWorkRef.name }} - {{ pData.description }}
                </a>
            </div>
            <div class="col-xs-5">
                <div class="input-group">
                    <input type="text" class="form-control text-center" :value="timerHMS" disabled>
                    <span class="input-group-btn">
                        <a v-show="resumeTimerButtonVisible"
                           class="btn btn-info ajax-support show-waiting"
                           :href="resumeTimerUrl"
                           data-ajax-support-csv="#ajaxModuleForm"
                           :title="pDictionary['dictionary.project.timelog.mode.TIMER.start.hint']">
                            <i class="fa-light fa-play"></i>
                         </a>
                        <a v-show="pauseTimerButtonVisible"
                           class="btn btn-warning ajax-support show-waiting"
                           :href="pauseTimerUrl"
                           data-ajax-support-csv="#ajaxModuleForm"
                           :title="pDictionary['dictionary.project.timelog.mode.TIMER.pause.hint']">
                            <i class="fa-light fa-pause"></i>
                         </a>
                         <a v-show="stopTimerButtonVisible"
                            class="btn btn-danger ajax-support show-waiting"
                            :href="stopTimerUrl"
                            data-ajax-support-csv="#ajaxModuleForm"
                            :title="pDictionary['dictionary.project.timelog.mode.TIMER.stop.hint']">
                             <i class="fa-light fa-stop"></i>
                         </a>
                   </span>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormatMixin from "@/mixins/format-mixin";
import dateHelpers from "@/helpers/date-helpers";
import urlhelpers from "@/helpers/url-helpers";

export default {
   name: "ProjectTimeLogTimerListItem",
   mixins: [BaseMixin, FormatMixin],
   props: {
      pData: Object
   },
   data: function() {
      return {
         nowMillis: Date.now()
      }
   },
   methods: {
      refreshNow: function () {
         let _component = this;
         _component.nowMillis = Date.now();
         setTimeout(() => {
            _component.refreshNow();
         }, 1000);
      }
   },
   computed: {
      viewProjectUrl: function () {
         let url = this.pUrls['viewProject'] + "?dataId=" + this.pData.mediaWorkRef.id;
         url = urlhelpers.appendIfDefined(url, 'src', this.pSrc);
         url = urlhelpers.appendIfDefined(url, 'srcId', this.pSrcId);
         return url;
      },
      resumeTimerButtonVisible: function() {
         return !this.pData.timerRunning;
      },
      resumeTimerUrl: function () {
         let url = this.pUrls['resumeProjectTimeLogTimer'] + "?dataId=" + this.pData.id;
         url = urlhelpers.appendIfDefined(url, 'src', this.pSrc);
         url = urlhelpers.appendIfDefined(url, 'srcId', this.pSrcId);
         return url;
      },
      pauseTimerButtonVisible: function() {
         return this.pData.timerRunning;
      },
      pauseTimerUrl: function () {
         let url = this.pUrls['pauseProjectTimeLogTimer'] + "?dataId=" + this.pData.id;
         url = urlhelpers.appendIfDefined(url, 'src', this.pSrc);
         url = urlhelpers.appendIfDefined(url, 'srcId', this.pSrcId);
         return url;
      },
      stopTimerButtonVisible: function() {
         return true;
      },
      stopTimerUrl: function () {
         let url = this.pUrls['stopProjectTimeLogTimer'] + "?dataId=" + this.pData.id;
         url = urlhelpers.appendIfDefined(url, 'src', this.pSrc);
         url = urlhelpers.appendIfDefined(url, 'srcId', this.pSrcId);
         return url;
      },
      timerMillis: function () {
         return this.pData.timerRunning ? this.nowMillis - this.pData.timerStartDateTimeMillis : 0;
      },
      timerHMS: function () {
         return dateHelpers.millisToHMS(this.timerMillis);
      }
   },
   mounted: function () {
      if(this.pData.timerRunning) {
         this.refreshNow();
      }

      // let _component = this;
      // const $projectTimeLogTimerListItemRef = $(_component.$refs.projectTimeLogTimerListItemRef);
      // $projectTimeLogTimerListItemRef.find('[data-toggle="tooltip"]').tooltip({sanitize: false, container: 'body'});
   },
   destroyed: function()
   {
      // let _component = this;
      // const $projectTimeLogTimerListItemRef = $(_component.$refs.projectTimeLogTimerListItemRef);
      // $projectTimeLogTimerListItemRef.find('[data-toggle="tooltip"]').tooltip('destroy');
   }
}
</script>

<style scoped>

</style>